import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

export type AvailabilityStatus = 'available' | 'unavailable'

export interface UpdateAvailabilityRequestArgs {
  gameId: string
  requestId: string
  status: AvailabilityStatus
}

export const updateAvailabilityRequestStatus = async ({
  gameId,
  requestId,
  status,
}: UpdateAvailabilityRequestArgs): Promise<void> => {
  await req(ENDPOINTS.GAMES.UPDATE_AVAILABILITY_REQUEST(gameId, requestId), {
    method: 'PUT',
    body: JSON.stringify({ status }),
  })
}

export interface PromoteAvailabilityRequestArgs {
  gameId: string
  requestId: string
}

// Promote a spare (whose availability request is 'available') onto the roster.
export const promoteAvailabilityRequest = async ({
  gameId,
  requestId,
}: PromoteAvailabilityRequestArgs): Promise<void> => {
  await req(ENDPOINTS.GAMES.PROMOTE_AVAILABILITY_REQUEST(gameId, requestId), {
    method: 'POST',
  })
}

// Undo a promote — remove the spare from the roster (same path, DELETE).
export const demoteAvailabilityRequest = async ({
  gameId,
  requestId,
}: PromoteAvailabilityRequestArgs): Promise<void> => {
  await req(ENDPOINTS.GAMES.PROMOTE_AVAILABILITY_REQUEST(gameId, requestId), {
    method: 'DELETE',
  })
}

// Withdraw a pending availability request entirely.
// DELETE /games/{game}/availability-requests/{id}
export const withdrawAvailabilityRequest = async ({
  gameId,
  requestId,
}: PromoteAvailabilityRequestArgs): Promise<void> => {
  await req(ENDPOINTS.GAMES.UPDATE_AVAILABILITY_REQUEST(gameId, requestId), {
    method: 'DELETE',
  })
}
